export default "__VITE_ASSET__BKkLzRgY__"